import { Redirect, Route, Switch } from 'react-router';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Tabs from '../../components/Tabs';
import { DAILY_RANK_AUDIO_BOOKS, DailyRankEndpoints, Routes, TAB_NAME } from '../../core/constants';
import { DailyRankEbooks, DailyRankAudioBooks, DailyRankCatalogue, DailyRankPrint } from '../Common/tabs';
import { useUserPermit } from '../../context/User.context';
import '../Common/styles.css';
import SavedSearchSection from '../SavedSearches/SavedSearch.section';
import { defaultSort, useSort } from '../../context/Sort.context';

const tabs = [
  {
    key: Routes.dailyRankAudiobooks,
    label: TAB_NAME.dailyRankAudioBooks
  },
  {
    key: Routes.dailyRankPrint,
    label: TAB_NAME.dailyRankPrint
  },
  {
    key: Routes.dailyRankEbooks,
    label: TAB_NAME.dailyRankEbooks
  },
  {
    key: Routes.dailyRankCatalogue,
    label: TAB_NAME.dailyRankCatalogue
  },
  {
    key: Routes.savedSearchesDailyRank,
    label: TAB_NAME.savedSearches
  }
];

const DailyrankSection: React.FC = ():JSX.Element => {
  const { view_tables } = useUserPermit();
  const { setSort } = useSort();
  const history = useHistory();

  return view_tables ? (
    <>
      <Tabs
        defaultActiveKey={DailyRankEndpoints[DAILY_RANK_AUDIO_BOOKS]}
        onChange={key => {
          history.push(key);

          if (!window.location.search) {
            setSort(defaultSort);
          }
        }}
        tabs={tabs}
        activeKey={window.location?.pathname}
      />

      <Switch>
        <Route path={Routes.dailyRankEbooks} render={() => <DailyRankEbooks />} />
        <Route path={Routes.dailyRankAudiobooks} render={() => <DailyRankAudioBooks />} />
        <Route path={Routes.dailyRankCatalogue} render={() => <DailyRankCatalogue />} />
        <Route path={Routes.savedSearchesDailyRank} render={() => <SavedSearchSection />} />
        <Route path={Routes.dailyRankPrint} render={() => <DailyRankPrint />}/>
        <Redirect to={Routes.dailyRankAudiobooks} />
      </Switch>
    </>
  ) : (
    <></>
  );
};

export default DailyrankSection;